import { useId } from 'react';

interface ILoadingIconProps {
  color?: [string, string];
  size?: number;
  className?: string;
}

export const LoadingIcon = ({
  color = ['rgba(255,255,255,0)', 'rgba(255,255,255,1)'],
  size = 16,
  className = ''
}: ILoadingIconProps) => {
  const id = useId();
  const maskId = `loading-mask-${id}`;
  const clipPathId = `loading-clip-path-${id}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ animation: 'spin 1s linear infinite' }}
    >
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <mask id={maskId} fill="white">
        <path d="M18.3332 10C18.3332 14.6024 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6024 1.6665 10C1.6665 5.39763 5.39746 1.66667 9.99984 1.66667C14.6022 1.66667 18.3332 5.39763 18.3332 10Z" />
      </mask>
      <g clipPath={`url(#${clipPathId})`} mask={`url(#${maskId})`}>
        <g transform="matrix(0.00833333 0 0 0.00833333 9.99984 10)">
          <foreignObject x="-1200" y="-1200" width="2400" height="2400">
            <div
              style={{
                background: `conic-gradient(from 90deg, ${color[0]} 0deg, ${color[1]} 360deg)`,
                height: '100%',
                width: '100%',
                opacity: 1
              }}
              data-icon
            />
          </foreignObject>
        </g>
      </g>
      <path
        d="M18.3332 10H16.6665C16.6665 13.6819 13.6817 16.6667 9.99984 16.6667V18.3333V20C15.5227 20 19.9998 15.5229 19.9998 10H18.3332ZM9.99984 18.3333V16.6667C6.31794 16.6667 3.33317 13.6819 3.33317 10H1.6665H-0.000162721C-0.000162721 15.5229 4.47699 20 9.99984 20V18.3333ZM1.6665 10H3.33317C3.33317 6.31811 6.31794 3.33334 9.99984 3.33334V1.66667V5.126e-06C4.47699 5.126e-06 -0.000162721 4.47716 -0.000162721 10H1.6665ZM9.99984 1.66667V3.33334C13.6817 3.33334 16.6665 6.31811 16.6665 10H18.3332H19.9998C19.9998 4.47716 15.5227 5.126e-06 9.99984 5.126e-06V1.66667Z"
        mask={`url(#${maskId})`}
      />
      <defs>
        <clipPath id={clipPathId}>
          <path
            d="M18.3332 10H16.6665C16.6665 13.6819 13.6817 16.6667 9.99984 16.6667V18.3333V20C15.5227 20 19.9998 15.5229 19.9998 10H18.3332ZM9.99984 18.3333V16.6667C6.31794 16.6667 3.33317 13.6819 3.33317 10H1.6665H-0.000162721C-0.000162721 15.5229 4.47699 20 9.99984 20V18.3333ZM1.6665 10H3.33317C3.33317 6.31811 6.31794 3.33334 9.99984 3.33334V1.66667V5.126e-06C4.47699 5.126e-06 -0.000162721 4.47716 -0.000162721 10H1.6665ZM9.99984 1.66667V3.33334C13.6817 3.33334 16.6665 6.31811 16.6665 10H18.3332H19.9998C19.9998 4.47716 15.5227 5.126e-06 9.99984 5.126e-06V1.66667Z"
            mask={`url(#${maskId})`}
          />
        </clipPath>
      </defs>
    </svg>
  );
};
